const WarCard = require("../../entities/Cards/WarCard");
const Wars = require("../../Constants/Wars/Wars");
const ByName = require("./ByName");

const classOf = ByName(Wars);

const WarConverter = (warName) =>
{
    const Class = classOf(warName);
    return Class === undefined ? null : new WarCard(new Class());
}

module.exports = WarConverter;
